import { currentUrl, replaceState } from '@avensia/excite';
import { SEARCH_PARAMS_PAGE } from './facets';

export const SEARCH_PARAMS_SORT_BY = 'sortBy';
export function updateUrlWithSortBySearchParams(sortBy: string) {
  const url = currentUrl();
  url.searchParams.delete(SEARCH_PARAMS_PAGE);
  url.searchParams.delete(SEARCH_PARAMS_SORT_BY);
  url.searchParams.append(SEARCH_PARAMS_SORT_BY, String(sortBy));
  replaceState(url);
}
